import ScrollLock from './scroll_lock';

export const getScrollLockStore = () => {
    if (!Alpine.store('scrollLock')) {
        Alpine.store('scrollLock', new ScrollLock());
    }

    return Alpine.store('scrollLock') as ScrollLock;
};
